import { Controller } from "@hotwired/stimulus"

// "Volume pricing" checkbox: default OFF = single price. Checking reveals
// up to 3 tier rows; UNchecking hides them AND clears every field, so
// saving genuinely removes the tiers (the model setter drops blank rows).
export default class extends Controller {
  static targets = ["checkbox", "rows", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const on = this.checkboxTarget.checked
    this.rowsTarget.classList.toggle("hidden", !on)
    if (!on) {
      this.fieldTargets.forEach(f => f.value = "")
    }
  }
}
